import { PREFIX_API } from 'constants/api.const';
import { map } from 'lodash';
import {
  GetLayoutPhotoRequestModel,
  GetLayoutPhotoResponseModel,
  LayoutPhotoStateModel,
  ListLayoutPhotoByThemeIdAndFrameIdRequestModel,
  ListLayoutPhotoRequestModel,
  ListLayoutPhotoResponseModel,
} from 'models/photo/layout.model';
import qs from 'qs';
import { baseSliceApi } from './base.slice-api';

export const layoutsApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    listLayoutApiAction: build.query<
      LayoutPhotoStateModel['listLayoutPhotos'],
      ListLayoutPhotoRequestModel
    >({
      query: () => ({
        url: `${PREFIX_API.API}/layout/getlist`,
      }),
      providesTags: (data) => [
        ...map(data?.data, ({ id }) => ({ type: 'LayoutPhoto', id } as const)),
        { type: 'LayoutPhoto' as const, id: 'LIST' },
      ],
      transformResponse: (rawResult: ListLayoutPhotoResponseModel) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
    listLayoutByThemeIdAndFrameIdApiAction: build.query<
      LayoutPhotoStateModel['listLayoutPhotos'],
      ListLayoutPhotoByThemeIdAndFrameIdRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/layouttheme/get-by-themeid?${qs.stringify(
          payload,
        )}`,
      }),
      providesTags: (data) => [
        ...map(data?.data, ({ id }) => ({ type: 'LayoutPhoto', id } as const)),
        { type: 'LayoutPhoto' as const, id: 'LIST' },
      ],
      transformResponse: (rawResult: ListLayoutPhotoResponseModel) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
    getLayoutByIdApiAction: build.query<
      GetLayoutPhotoResponseModel,
      GetLayoutPhotoRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/layout/getbyid?${qs.stringify(payload)}`,
      }),
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const {
  useListLayoutApiActionQuery,
  useListLayoutByThemeIdAndFrameIdApiActionQuery,
  useGetLayoutByIdApiActionQuery,
  useLazyGetLayoutByIdApiActionQuery,
} = layoutsApi;

export const {
  endpoints: {
    listLayoutApiAction,
    listLayoutByThemeIdAndFrameIdApiAction,
    getLayoutByIdApiAction,
  },
} = layoutsApi;
